// Minimal generation-token guard for async work keyed by a value that can change
// before that work resolves (e.g. the operation currently being viewed). Each call to
// start() bumps the generation and returns the request's own token; isStale(token)
// tells the caller whether a newer request has started since, so a late response for
// an operation the user has already navigated away from is never applied on top of
// the newer operation's state. Sibling of createSingleFlightGuard (services/
// singleFlightGuard.js, used for double-submit protection) -- this one is not a
// latch, multiple requests may be in flight, only the latest one's result is applied.
export function createStaleRequestGuard() {
  let generation = 0;

  return {
    start: () => ++generation,
    isStale: (requestId) => requestId !== generation,
  };
}
